// @systeme: interface
import { useState, type FormEvent } from 'react';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { Link as LienRouteur, useSearchParams } from 'react-router';
import { FormulaireAuth } from '../composants/FormulaireAuth';
import { messageDe } from '../composants/Messages';
import { api } from '../lib/api';
import { useSession } from '../session/SessionContext';

export function Connexion() {
  const { connecter, mettreAJour } = useSession();
  const [parametres] = useSearchParams();
  const invitation = parametres.get('invitation');
  const [email, setEmail] = useState('');
  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState<string | undefined>();
  const [enCours, setEnCours] = useState(false);

  async function soumettre(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setErreur(undefined);
    setEnCours(true);
    try {
      await connecter({ email, motDePasse });
      // Venue par un lien d'invitation : on rejoint le foyer dans la foulée.
      if (invitation) mettreAJour(await api.invitations.accepter(invitation));
    } catch (err) {
      setErreur(messageDe(err));
    } finally {
      setEnCours(false);
    }
  }

  return (
    <FormulaireAuth
      titre="Bonjour"
      sousTitre="Ce que tu as dans la tête, sorti en dix secondes. Rien ne se perd."
      erreur={erreur}
      onSoumettre={soumettre}
      pied={
        <Stack spacing={1.5}>
          <Link component={LienRouteur} to="/mot-de-passe-oublie">
            Mot de passe oublié ?
          </Link>
          <Link
            component={LienRouteur}
            to={invitation ? `/inscription?invitation=${invitation}` : '/inscription'}
          >
            Première fois ici ? Créer un compte
          </Link>
        </Stack>
      }
    >
      <TextField
        label="Ton adresse courriel"
        type="email"
        autoComplete="email"
        inputMode="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <TextField
        label="Ton mot de passe"
        type="password"
        autoComplete="current-password"
        value={motDePasse}
        onChange={(e) => setMotDePasse(e.target.value)}
        required
      />
      <Button type="submit" variant="contained" size="large" disabled={enCours}>
        Me connecter
      </Button>
    </FormulaireAuth>
  );
}
